import { instance } from 'api/internaltools';

export const getBeneficiarySuperMerchants = async () => {
  return instance.get('/beneficiaries/super-merchants');
};

export const getSuperMerchantBeneficiaries = async (superMerchantId, { status, page, pageSize, searchParams } = {}) => {
  return instance.get(`/beneficiaries/super-merchant/${superMerchantId}`, {
    params: {
      status,
      page,
      pageSize,
      search_params: searchParams || undefined,
    },
  });
};

export const getBeneficiaryDetails = async (beneficiaryId) => {
  return instance.get(`/beneficiaries/details/${beneficiaryId}`);
};

export const updateBeneficiaryStatus = async (beneficiaryId, payload) => {
  return instance.patch(`/beneficiaries/${beneficiaryId}/status`, payload);
};

export const uploadBeneficiaryDocument = async (beneficiaryId, payload) => {
  return instance.post(`/beneficiaries/${beneficiaryId}/document`, payload);
};
